import { render, staticRenderFns } from "./ybScan.vue?vue&type=template&id=49b98df0&scoped=true"
import script from "./ybScan.vue?vue&type=script&lang=js"
export * from "./ybScan.vue?vue&type=script&lang=js"
import style0 from "./ybScan.vue?vue&type=style&index=0&id=49b98df0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b98df0",
  null
  
)

export default component.exports